import { useRouterState } from "@tanstack/react-router";
import { useEffect } from "react";
import { useLoadingBar } from "react-top-loading-bar";

export function useNavLoadingBar() {

  const isPageLoading = useRouterState({
    select: (s) => s.status === 'pending',
  });

  const { start, complete } = useLoadingBar({
    className: "!bg-primary-400",
    height: 2,
    shadowStyle: {
      boxShadow: "0 0 10px var(--color-primary-400)",
      opacity: 1,
      position: "absolute",
      height: "100%",
      transition: `all 500ms ease`,
      transform: "rotate(2deg) translate(0px, -2px)",
    },
  });

  useEffect(() => {
    if (isPageLoading) {
      start();
    } else {
      complete();
    }
  }, [complete, isPageLoading, start]);
}
